import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {BACKEND,client_id,idme_url,idme_redirect_uri,idme_scope} from '../../../../config'

@Component({
  selector: 'app-verification-popup',
  templateUrl: './verification-popup.component.html',
  styleUrls: ['./verification-popup.component.css']
})
export class VerificationPopupComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<any>,
  ) { }
  closeModel() {
    this.dialogRef.close();
  }
  openIDme() {
    // tslint:disable-next-line:max-line-length
    window.open(''+idme_url+'/oauth/authorize?client_id='+client_id+'&redirect_uri=' + idme_redirect_uri + '&response_type=code&scope=authentication&state=488e864b' , '_self');
  }
  federated(): void {
    // tslint:disable-next-line:max-line-length
    window.open(''+idme_url+'/oauth/authorize?client_id='+client_id+'&redirect_uri='+ idme_redirect_uri +'&response_type=code&scope='+idme_scope+'&state=488e864b' , '_self');
    }
  signUP() {
 // tslint:disable-next-line:max-line-length
   window.open(''+idme_url+'/oauth/authorize?client_id='+client_id+'&redirect_uri='+ idme_redirect_uri +'&response_type=code&scope=authentication&state=488e864b&op=signup' , '_self');
  }
  ngOnInit() {
  }
  

}
